import { render } from "./EditPageKeywords.vue?vue&type=template&id=24d7761e&scoped=true"
import script from "./EditPageKeywords.vue?vue&type=script&lang=js"
export * from "./EditPageKeywords.vue?vue&type=script&lang=js"

import "./EditPageKeywords.vue?vue&type=style&index=0&id=24d7761e&lang=scss"
import "./EditPageKeywords.vue?vue&type=style&index=1&id=24d7761e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d7761e"]])

export default __exports__